export const RECORDER_TAKE = 2000;
export const TABLE_BG_COLOR = "#fafaff";
export const TABLE_BORDER_COLOR = "#ebebf7";
